export const common = {
  siteName: 'AllChinaBuy Spreadsheet',
  tagline: 'Produktressourcer, Sælgere & Købsvejledninger',
  explore: 'Udforsk AllChinaBuy Spreadsheet',
  browseGuides: 'Gennemse Købsvejledninger',
  buyItNow: 'Køb Nu',
  allchinabuySpreadsheet: 'AllChinaBuy Spreadsheet',
  visitMainSite: 'Besøg Hovedbutik',
  searchPlaceholder: 'Søg efter AllChinaBuy produkter, sælgere, fragt eller vejledninger...',
  categories: 'Kategorier',
  articles: 'Artikler',
  guides: 'Vejledninger',
  reviews: 'Anmeldelser',
  shipping: 'Fragt',
  coupon: 'Kupon',
  warehouse: 'Lager',
  legit: 'Er Det Legitimt?',
  about: 'Om Os',
  contact: 'Kontakt',
  faq: 'FAQ',
  privacy: 'Privatlivspolitik',
  terms: 'Servicevilkår',
  disclaimer: 'Ansvarsfraskrivelse',
  home: 'Hjem',
  readMore: 'Læs Mere',
  relatedArticles: 'Relaterede Artikler',
  tableOfContents: 'Indholdsfortegnelse',
  lastUpdated: 'Sidst Opdateret',
  author: 'Forfatter',
  share: 'Del',
  question: 'Har du et Spørgsmål?',
  ctaMainTitle: 'Klar til at Handle?',
  ctaMainDesc: 'Besøg vores hovedbutik for den fulde AllChinaBuy produktkatalog.',
  ctaMainButton: 'Gå til Hovedbutik',
  footerDesc: 'AllChinaBuy Spreadsheet er din organiserede ressource for AllChinaBuy produkter, sælgere, fragtvejledninger og købstips.',
  copyright: 'Alle rettigheder forbeholdes.',
  notAffiliated: 'Ikke tilknyttet AllChinaBuy. Kun informationsressource.',
  language: 'Sprog',
  english: 'Engelsk',
  french: 'Fransk',
  german: 'Tysk',
  danish: 'Dansk',
  breadcrumbHome: 'Hjem',
  minutesRead: 'min. læsning',
  quickLinks: 'Hurtige Links',
  resources: 'Ressourcer',
  legal: 'Juridisk',
  scrollToTop: 'Rul til top',
  viewAll: 'Se Alt',
  allProducts: 'Alle Produkter',
  buyNow: 'Køb Nu',
  productsPageTitle: 'AllChinaBuy Produkter — Sko, Tøj, Tilbehør & Mere',
  productsPageDescription: 'Gennemse 100+ verificerede produkter fra AllChinaBuy spreadsheet. Sko, hættetrøjer, t-shirts, jakker, tilbehør, tasker, parfumer og mere med direkte købslinks.',
  pageNotFound: 'Side Ikke Fundet',
  pageNotFoundDesc: 'Den side du leder efter findes ikke.',
  featuredProducts: 'Udvalgte Produkter',
  featuredProductsDesc: 'Håndplukkede varer fra vores AllChinaBuy katalog',
  viewAllProducts: 'Se Alle Produkter',
};

export const nav = {
  home: 'Hjem',
  products: 'Produkter',
  categories: 'Kategorier',
  articles: 'Artikler',
  reviews: 'Anmeldelser',
  shipping: 'Fragt',
  coupon: 'Kupon',
  warehouse: 'Lager',
  legit: 'Legitimt?',
  about: 'Om Os',
};

export const hero = {
  h1: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsressourcer Hurtigere',
  subtitle: 'Udforsk AllChinaBuy ressourcer, produkter, sælgere, QC-information, fragtvejledninger, anmeldelser og købstips på ét organiseret sted.',
  ctaPrimary: 'Udforsk AllChinaBuy Spreadsheet',
  ctaSecondary: 'Gennemse Købsvejledninger',
  searchPlaceholder: 'Søg efter produkter, sælgere, fragt eller vejledninger...',
};

export const categories = {
  title: 'Populære AllChinaBuy Kategorier',
  subtitle: 'Gennemse de mest populære produktkategorier på AllChinaBuy',
  shoes: 'Sko',
  hoodiesSweaters: 'Hættetrøjer & Sweaters',
  tshirts: 'T-Shirts',
  jackets: 'Jakker',
  pantsShorts: 'Bukser & Shorts',
  headwear: 'Hovedbeklædning',
  sets: 'Sæt',
  underwear: 'Undertøj',
  jersey: 'Trøjer',
  accessories: 'Tilbehør',
  bags: 'Tasker',
  belts: 'Bælter',
  perfumes: 'Parfumer',
  otherStuff: 'Andet',
  viewAll: 'Se Alle Kategorier',
};

export const homeSections = {
  popularSearchesTitle: 'Populære AllChinaBuy Søgninger',
  popularSearchesDesc: 'Opdag, hvad købere leder efter lige nu',
  spreadsheetHubTitle: 'AllChinaBuy Spreadsheet Hub',
  spreadsheetHubDesc: 'Din komplette ressource for organiserede produkt- og sælgeroplysninger',
  resourcesTitle: 'Produkt- & Sælgerressourcer',
  resourcesDesc: 'Omfattende vejledninger til at hjælpe dig med at navigere på AllChinaBuy',
  reviewTitle: 'AllChinaBuy Anmeldelse',
  reviewDesc: 'Ærlige, dybdegående anmeldelser fra rigtige købere og vores redaktionelle team',
  shippingTitle: 'AllChinaBuy Fragtomkostninger',
  shippingDesc: 'Sammenlign fragtmetoder, linjer, tider og omkostninger for din region',
  couponTitle: 'Kupon & Rabatkode',
  couponDesc: 'Senest verificerede kuponer, rabatkoder og tilbud til AllChinaBuy',
  warehouseTitle: 'Lagervejledning',
  warehouseDesc: 'Forstå, hvordan AllChinaBuy lagre fungerer, og optimer din opbevaring',
  legitTitle: 'Er AllChinaBuy Legitimt?',
  legitDesc: 'Sikkerhedsvejledning, tillidsanalyse og svindelbevidsthed for AllChinaBuy-købere',
  comparisonTitle: 'Sammenligningstabeller',
  comparisonDesc: 'Se, hvordan AllChinaBuy klarer sig sammenlignet med andre købsagenter',
  articlesTitle: 'Seneste Artikler',
  articlesDesc: 'Friske vejledninger, tips og indsigter for AllChinaBuy-købere',
  faqTitle: 'Ofte Stillede Spørgsmål',
  faqDesc: 'Hurtige svar på almindelige AllChinaBuy-spørgsmål',
  finalCtaTitle: 'Start Din AllChinaBuy Rejse',
  finalCtaDesc: 'Besøg vores hovedbutik for den komplette katalog og de seneste tilbud.',
  finalCtaButton: 'Besøg Hovedbutik',
};

export const articles = {
  allchinabuySpreadsheetGuide: 'AllChinaBuy Spreadsheet Vejledning: Komplet Produkt- & Sælgerkatalog 2026',
  allchinabuySpreadsheetGuideDesc: 'Den mest omfattende vejledning til brug af AllChinaBuy spreadsheets. Lær at finde produkter, sælgere, QC-fotos og fragtinfo hurtigere.',
  allchinabuyReview2026: 'AllChinaBuy Anmeldelse 2026: Funktioner, Fragt & Købsvejledning',
  allchinabuyReview2026Desc: 'En ærlig anmeldelse af AllChinaBuy funktioner, fordele, ulemper, fragt og købsoplevelse. Opdateret for 2026.',
  allchinabuyShippingCost: 'AllChinaBuy Fragtomkostninger: Komplet Vejledning & Sammenligning',
  allchinabuyShippingCostDesc: 'Sammenlign fragtlinjer, omkostninger, leveringstider og toldtips for AllChinaBuy ordrer.',
  allchinabuyCoupon: 'AllChinaBuy Kupon & Rabatkode: Vejledning til Seneste Tilbud',
  allchinabuyCouponDesc: 'Find de seneste verificerede AllChinaBuy kuponer, rabatkoder og kampagner.',
  allchinabuyWarehouseGuide: 'AllChinaBuy Lagervejledning: Opbevaring, QC & Fragt',
  allchinabuyWarehouseGuideDesc: 'Alt hvad du behøver at vide om AllChinaBuy lagre, opbevaring og kvalitetskontrol.',
  isAllchinabuyLegit: 'Er AllChinaBuy Legitimt? Sikkerheds- & Tillidsvejledning 2026',
  isAllchinabuyLegitDesc: 'Sikkerhedsanalyse, tillidsindikatorer, svindelbevidsthed og tips til sikker køb på AllChinaBuy.',
  allchinabuyVsSuperbuy: 'AllChinaBuy vs Superbuy: Detaljeret Sammenligning 2026',
  allchinabuyVsSuperbuyDesc: 'Sammenligning af AllChinaBuy og Superbuy funktioner, fragt, QC og prissætning.',
  allchinabuyBeginnerGuide: 'AllChinaBuy Begyndervejledning: Sådan Køber Du Trin for Trin',
  allchinabuyBeginnerGuideDesc: 'Ny på AllChinaBuy? Denne trin-for-trin vejledning fører dig fra registrering til fragt.',
};

export const articleContent = {
  spreadsheetGuideTitle: 'AllChinaBuy Spreadsheet Vejledning: Komplet Produkt- & Sælgerkatalog 2026',
  spreadsheetGuideIntro: 'AllChinaBuy er blevet en af de mest populære købsagenter for internationale købere, der søger produkter på kinesiske markedspladser. Uanset om du leder efter sneakers, streetwear, tilbehør eller nichefund, hjælper AllChinaBuy spreadsheet-økosystemet dig med at organisere produktlinks, sælgeroplysninger, QC-fotos og priser på ét sted. Denne vejledning er den mest komplette ressource til at forstå, hvordan du bruger AllChinaBuy spreadsheets til at handle klogere, spare penge og undgå almindelige fejl.',
  whatIsSpreadsheetTitle: 'Hvad er et AllChinaBuy Spreadsheet?',
  whatIsSpreadsheetContent: 'Et AllChinaBuy Spreadsheet er et kurateret dokument eller en database, der indeholder organiserede links til produkter, sælgere og købsressourcer på AllChinaBuy. Disse spreadsheets kan inkludere kategorier som sko, tøj, tilbehør, tasker og mere. De indeholder ofte produktnavne, sælgernavne, priser, QC-fotolinks, størrelsestabeller og direkte købslinks. Målet er at spare købere tid ved at give en struktureret måde at gennemse og sammenligne produkter på.',
  whyUseSpreadsheetTitle: 'Hvorfor Bruge AllChinaBuy Spreadsheets?',
  whyUseSpreadsheetContent1: 'Spar tid — Spreadsheets giver direkte links til kuraterede produkter og betroede sælgere.',
  whyUseSpreadsheetContent2: 'Sammenlign priser — Se priser for lignende produkter hos forskellige sælgere på én gang.',
  whyUseSpreadsheetContent3: 'QC-fotos — Mange spreadsheets inkluderer links til kvalitetskontrolfotos.',
  whyUseSpreadsheetContent4: 'Betroede sælgere — Kuraterede spreadsheets fremhæver sælgere med gode anmeldelser.',
  whyUseSpreadsheetContent5: 'Community-drevet — De bedste spreadsheets vedligeholdes af køberfællesskaber.',
  howToUseSpreadsheetTitle: 'Sådan Bruger Du et AllChinaBuy Spreadsheet',
  howToUseSpreadsheetContent: 'At bruge et AllChinaBuy Spreadsheet er ligetil. Identificer først den kategori, du er interesseret i — sko, hættetrøjer, tilbehør. Åbn spreadsheetet og gennemse det relevante faneblad. Hver række indeholder typisk produktnavnet, sælgeren, prisen og et link. Klik på linket for at se produktet på markedspladsen. Før du køber, tjek om der er QC-fotos tilgængelige, og læs kuratorens noter. Tilføj produktet til din AllChinaBuy indkøbskurv, indsend købet, og vent på at varen ankommer til lageret. Når den ankommer, gennemse QC-fotosne og godkend eller anmod om returnering.',
  popularCategoriesTitle: 'Populære AllChinaBuy Spreadsheet Kategorier',
  popularCategoriesContent: 'De mest populære kategorier i AllChinaBuy spreadsheets inkluderer sko og sneakers, hættetrøjer og sweaters, t-shirts, jakker, bukser og shorts, hovedbeklædning, tilbehør, tasker, bælter og parfumer. Hver kategori har sine egne betroede sælgere og produktsortimenter.',
  spreadsheetTipsTitle: 'Tips til at Få Mest Muligt ud af Spreadsheets',
  spreadsheetTipsContent1: 'Bekræft altid sælgerens omdømme før køb — tjek anmeldelser og nylig feedback.',
  spreadsheetTipsContent2: 'Sammenlign priser på tværs af flere spreadsheets — forskellige kuratorer kan have forskellige tilbud.',
  spreadsheetTipsContent3: 'Join fællesskaber — Discord-servere, Reddit-fora og Telegram-grupper deler ofte de nyeste spreadsheets.',
  spreadsheetTipsContent4: 'Tjek QC-fotos omhyggeligt — hvad du ser i spreadsheetet kan afvige lidt fra slutproduktet.',
  spreadsheetTipsContent5: 'Gem dine favoritspreadsheets — bookmark dem, så du kan tjekke tilbage for opdateringer.',
  comparisonTitle: 'AllChinaBuy vs Andre Købsagenter',
  comparisonContent: 'Når man sammenligner AllChinaBuy med andre købsagenter som Superbuy, CSSBuy, Sugargoo og Basetao, har hver platform sine styrker. AllChinaBuy er populær for sin spreadsheet-venlige tilgang og community-delingskultur. Superbuy tilbyder mere poleret software og kundesupport. CSSBuy er kendt for konkurrencedygtige fragtrater. Sugargoo har en brugervenlig grænseflade. Basetao tilbyder en ældre, men pålidelig service. For spreadsheet-brugere foretrækkes AllChinaBuy ofte, da dens community aktivt deler og vedligeholder produktlister.',
  faqQuestion1: 'Er AllChinaBuy spreadsheets gratis at bruge?',
  faqAnswer1: 'Ja, de fleste AllChinaBuy spreadsheets er gratis og delt af community-medlemmer. Nogle kuratorer tilbyder muligvis premium spreadsheets med eksklusive fund mod en lille betaling.',
  faqQuestion2: 'Hvor ofte opdateres spreadsheets?',
  faqAnswer2: 'Det afhænger af kuratoren. Aktive community-spreadsheets opdateres ugentligt eller månedligt. Mindre aktive kan være forældede. Tjek altid seneste opdateringsdato.',
  faqQuestion3: 'Kan jeg stole på alle sælgere i et spreadsheet?',
  faqAnswer3: 'Ikke alle sælgere er lige pålidelige. Ansete spreadsheets inkluderer normalt noter om sælgerkvalitet. Bekræft altid ved at tjekke nylige anmeldelser og QC-fotos.',
  faqQuestion4: 'Hvad skal jeg gøre, hvis et produktlink er ødelagt?',
  faqAnswer4: 'Hvis et produktlink er ødelagt, prøv at søge efter produkt- eller sælgernavnet direkte på markedspladsen. Du kan også spørge kuratoren eller fællesskabet om et opdateret link.',
  conclusionTitle: 'Konklusion',
  conclusionContent: 'AllChinaBuy spreadsheets er et uvurderligt værktøj for internationale købere, der ønsker at spare tid, sammenligne produkter og købe med tillid. Ved at bruge kuraterede spreadsheets kan du få adgang til betroede sælgere, QC-fotos og organiserede produktkategorier på ét sted. Uanset om du er nybegynder eller erfaren køber, giver denne vejledning dig alt, hvad du har brug for, til at bruge AllChinaBuy spreadsheets effektivt i 2026.',
  backToHome: 'Tilbage til Hjem',
  nextArticle: 'Næste Artikel',
  prevArticle: 'Forrige Artikel',
  writtenBy: 'Skrevet af',
  publishedOn: 'Udgivet den',
  updatedOn: 'Opdateret den',
  readingTime: 'Læsetid',
};

export default {
  ...common,
  ...nav,
  ...hero,
  ...categories,
  ...homeSections,
  ...articles,
  ...articleContent,
};